<template>
  <div>
    
    <MultiSelect
      :modelValue="modelValue"
      @update:modelValue="value => emit('update:modelValue', value)"
      :options="options"
      :idField="resolvedIdField"
      :labelField="resolvedLabelField"
      :placeholder="placeholder"
      :disabled="disabled"
      
    />
    <p v-if="error === true" class="text-error text-xs mt-1">{{ errorMessage }}</p>
  </div>
</template>

<script setup>
import MultiSelect from '@/components/MultiSelect.vue';
import { defineProps, defineEmits, computed } from 'vue';
import { useI18n } from '@/i18n';

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  options: { type: Array, default: () => [] },
  error: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
  disabled: { type: Boolean, default: false }
});
const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();

const label = t('aiChatAgentSetup.agentInformation.divisionsLabel', 'Divisions');
const placeholder = t('aiChatAgentSetup.agentInformation.divisionsSelector.selectButton', 'Select Divisions');

const resolvedIdField = computed(() => {
  const opts = Array.isArray(props.options) === true ? props.options : [];
  const first = opts.length > 0 ? opts[0] : null;
  if (first !== null && first !== undefined && first.divisionId !== undefined && first.divisionId !== null) {
    return 'divisionId';
  }
  if (first !== null && first !== undefined && first.divisionid !== undefined && first.divisionid !== null) {
    return 'divisionid';
  }
  return 'divisionId';
});

const resolvedLabelField = computed(() => {
  const opts = Array.isArray(props.options) === true ? props.options : [];
  const first = opts.length > 0 ? opts[0] : null;
  if (first !== null && first !== undefined && first.divisionName !== undefined && first.divisionName !== null) {
    return 'divisionName';
  }
  if (first !== null && first !== undefined && first.divisionname !== undefined && first.divisionname !== null) {
    return 'divisionname';
  }
  return 'divisionName';
});
</script> 